import { ActivityResult, GetActivityOptions, IActivityApi } from "@connect/Interfaces";
import ApiV2 from "Api/ApiV2";

export default class ActivityApi extends ApiV2 implements IActivityApi {
	getActivityLog(companyUuid: string, options?: GetActivityOptions) {
		return this.GET(`companies/${ companyUuid }/activity-log`, options, true) as Promise<ActivityResult>;
	}
}
